import { useTranslate } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";

export const ContactEmpty = () => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col justify-center items-center gap-6 py-16">
      <img
        src="./img/empty.svg"
        alt=""
        aria-hidden="true"
        className="max-w-60"
      />
      <div className="flex flex-col gap-1 items-center">
        <h6 className="text-lg font-bold">
          {translate("resources.contacts.empty.title")}
        </h6>
        <p className="text-sm text-center text-muted-foreground">
          {translate("resources.contacts.empty.description")}
        </p>
      </div>
      <CreateButton label="resources.contacts.action.new" />
    </div>
  );
};
